export default {
  filterBtn: `Filter`,
  editBtn: `Edit Filters`,
  pageCount: (firstNumber, lastNumber, totalData) => `Showing ${firstNumber} - ${lastNumber} of ${totalData} products`,
  sortBy: `Sort by`
}
